import React from "react";
// import Typography from "../../components/typography/Typography";
import RegistrationForm from "./RegistrationForm";
import { Typography } from "antd";
import TeamPng from '../../assets/images/team.png'

import ParticlesBg from 'particles-bg'
import WebinarForm from "./WebinarForm";

export default function HeroRegistration() {

  return <div className=" relative w-full h-fit hero-section-wrapper"
  >
    <div className="absolute top-0 left-0 hero-section-bg w-full h-full md:h-[70%]"

    ></div>
    <div className="bg-overlay-gradient absolute w-full h-full md:h-[70%]"></div>

    {/* <ParticlesBg type="cobweb" bg={true} /> */}
    <section className="!pt-20 md:!pt-28 relative flex flex-col md:flex-row justify-between !max-w-[80rem] md:gap-8 section hero-section"
    >

      <div className="md:mt-16">
        <h1 className="!text-white !font-medium !text-3xl md:!text-5xl !mb-0" >
          We teach,
        </h1>
        <p className="text-[#F0C544] !font-semibold !text-3xl md:!text-5xl font-bold md:mt-2 mb-4" >
          what we master
        </p>
        <p className="text-white text-1xl mb-8 md:text-3xl !font-light" >Expert guidance to master your skills!</p>
      </div>
      <WebinarForm isWebinar />
    </section>
  </div>

}
